export default __webpack_public_path__ + "static/media/clinic4.0f62bcf6.jpg";